import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Icons from 'lucide-react';
import api from '../services/api';

const AlertBadge = () => {
    const [count, setCount] = useState(0);
    const navigate = useNavigate();

    const fetchCount = async () => {
        try {
            const response = await api.get('/alerts/count');
            setCount(response.data.count || 0);
        } catch (error) {
            console.error('Error fetching alert count:', error);
        }
    };

    useEffect(() => {
        fetchCount();

        // Poll every 30 seconds for updates
        const interval = setInterval(fetchCount, 30000);

        return () => clearInterval(interval);
    }, []);

    const handleClick = () => {
        navigate('/alerts');
    };

    if (count === 0) return null;

    return (
        <button
            onClick={handleClick}
            className="relative p-2 text-gray-600 hover:text-orange-600 hover:bg-orange-50 rounded-md transition-colors"
            title={`${count} alerta${count !== 1 ? 's' : ''} pendiente${count !== 1 ? 's' : ''}`}
        >
            <Icons.AlertTriangle className="w-5 h-5" />
            <span className="absolute top-0 right-0 flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full border-2 border-white">
                {count > 99 ? '99+' : count}
            </span>
        </button>
    );
};

export default AlertBadge;
